/** @file Row header text: entity names on groups, translated channel names, event names on event lanes. */
import type { TimelineRow } from '@pose2d/editor-geometry/types';
import type { CatalogKey, Translate } from '@pose2d/i18n/types';
import { dopeKeys } from './model/dopeKeys';

const CHANNELS = [
  'rotation', 'x', 'y', 'scaleX', 'scaleY', 'shearX', 'shearY', 'inherit', 'attachment', 'rgb', 'alpha', 'dark',
  'ikMix', 'ikSoftness', 'ikBend', 'ikStretch', 'ikCompress', 'deform', 'drawOrder',
] as const;
const CHANNEL_KEYS: ReadonlyMap<string, CatalogKey> = new Map(CHANNELS.map((c) => [c, `panels.timeline.channels.${c}` as const]));

/** The label a row header shows; an unknown channel shows its id. */
export function rowLabel(row: TimelineRow, t: Translate): string {
  if (row.channel === null && row.target === dopeKeys.DRAW_ORDER) return t('panels.timeline.drawOrder');
  if (row.channel === null && row.target === dopeKeys.EVENTS) return t('panels.timeline.events');
  if (row.label !== '') return row.label;
  const key = row.channel === null ? undefined : CHANNEL_KEYS.get(row.channel);
  return key === undefined ? (row.channel ?? row.target) : t(key);
}
